export default __webpack_public_path__ + "static/media/007-prohibition.5a3143e2.png";